import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Matt Stayner
 * id 62E619DA-599C-486F-AD85-9B5BAB4F5A92
 * name arrow-up-thin
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-up-thin.svg
 * tags
 * - Arrow 
 */
export const ArrowUpThinIcon = createSvgIcon(<><path d="M7.03 9.97H11.03V18.89L13.04 18.92V9.97H17.03L12.03 4.97Z" /></>, 'ArrowUpThinIcon');
export default ArrowUpThinIcon